import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { Report } from '../../../core/models';
import {
  ActivityFormatService, AgeGroupService, ArrayService, AuthService, ITPerformanceService,
  ChurchService, DatabaseService, DocumentService, FestivalUserService 
} from '../../../core/services';

import { PageClass } from '../../../core/classes/page';
import { Router } from '@angular/router';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.less', '../../../core/styles/common.less']
})

export class ReportListComponent extends PageClass implements OnInit {

  reportList: Report[] = [];

  constructor(
    protected activityFormatService: ActivityFormatService,
    protected itPerformanceService: ITPerformanceService,
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    protected documentService: DocumentService,
    protected modalController: ModalController,
    protected router: Router,
    protected festivalUserService: FestivalUserService,
    protected alertController: AlertController
  ) { 
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {

    if ((!this.currentUser.isReportViewer && !this.currentUser.isAdmin) || this.currentUser.isDeleted || !this.currentUser.isActive) {
      this.router.navigate(['/']);
    } else {
      
      this.reportList = [{
        displayName: 'Members Report',
        description: 'Report list all church participants',
        id: '665b9631-e665-4ca1-bb65-541d3946f15d',
        page: 'Kq70B'
      }, {
        displayName: 'Sport Teams Detailed Report',
        description: 'List of church sport teams including player names, age group',
        id: 'fa01e319-dabb-4cc7-83db-6dab374f4fcf',
        page: 'Kq70B'
      }, {
        displayName: 'Sport Teams Summary Report',
        description: 'List of church sport teams',
        id: '2456bc3b-484c-407e-90db-3b1d1ee066b0',
        page: 'Kq70B'
      }];

      this.isLoading = false;
    }
  }

  doRefresh = async (event: any) => {
    await this.loadData();
    event.target.complete();
  }

  openReport = (report: Report): void => {
    this.router.navigate(['/report', 'view', report.id, report.page]);
  }

  showErrorMessage = async (header: string, errorMessage: string) => {
    const alert = await this.alertController.create({
      header: header,
      message: errorMessage,
      buttons: ['OK'],
    });

    alert.onDidDismiss().then(() => { 
    });

    await alert.present();
  }
}
